import types from './types';

const receiveOmniEntity = (entity: any) => ({
  type: types.RECEIVE_OMNI_ENTITY,
  entity
});

export default { receiveOmniEntity };
